import type React from "react";

export function LinkBroken({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1170_840)">
        <path
          d="M7.08329 12.9165L12.9166 7.08315M7.49996 3.33317V1.6665M12.5 16.6665V18.3332M3.33329 7.49984H1.66663M16.6666 12.4998H18.3333M4.09514 4.09502L2.91663 2.9165M15.9048 15.9046L17.0833 17.0831M9.99999 14.7138L8.23222 16.4816C6.93047 17.7833 4.81992 17.7833 3.51818 16.4816C2.21643 15.1798 2.21643 13.0693 3.51818 11.7675L5.28594 9.99976M14.714 9.99976L16.4818 8.232C17.7835 6.93025 17.7835 4.8197 16.4818 3.51795C15.1801 2.2162 13.0695 2.2162 11.7678 3.51795L9.99999 5.28572"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
      </g>
      <defs>
        <clipPath id="clip0_1170_840">
          <rect fill="white" height="20" width="20" />
        </clipPath>
      </defs>
    </svg>
  );
}
